import { IScope } from "angular";
import { StateService } from "@uirouter/angularjs";

interface IAccountNotificationSettingsScope extends IScope {
  stateName: string;
  closeModal(): void;
}
export class AccountNotificationSettingsCtrl {
  public static $inject = ["$scope", "$state"];
  constructor(private $scope: IAccountNotificationSettingsScope, private $state: StateService) {
    this.$scope.closeModal = this.closeModal;
    this.$scope.stateName = this.$state.current.name;
  }

  private closeModal = (): void => {
    this.$state.go("^.^");
  };
}
